export default __webpack_public_path__ + "static/media/close.a553c8fe.svg";